export default __webpack_public_path__ + "static/media/midasi_entry_th_pc.9bb74144.png";